import {
   Checkbox as MantineCheckbox,
   CheckboxProps as MantineCheckboxProps,
} from '@mantine/core'

export const Checkbox = ({ ...props }: MantineCheckboxProps) => {
   return <MantineCheckbox {...props} color="#A684FF" />
}
